import { removeNotification } from './notificationsSlice'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { useReduxDispatch } from 'store'
import { useEffect } from 'react'

interface NotificationProps extends notifications.Notification { }

const DELAY = 5000

const Notification: React.FC<NotificationProps> = ({ id, translate, message, chatMessage, type }) => {
  const { t } = useTranslation('basic')
  const dispatch = useReduxDispatch()
  const { push } = useHistory()

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(removeNotification({ notificationId: id }))
    }, DELAY)
    return () => {
      clearTimeout(timeout)
    }
  }, [id, dispatch])

  return (
    <div className={`notification notification--${type}`}>
      <div className='center --gap1'>
        {(type === 'danger' || type === 'error')
          ? <i className='icon icon--warning' />
          : type === 'deleted'
            ? <i className='icon icon--trash' />
            : null}
        {translate
          ? <span className='notification__desc'>{t(message)}</span>
          : <span
            className='notification__desc'
            dangerouslySetInnerHTML={{ __html: message }}
          />}
      </div>

      <div className='center --gap05'>
        {chatMessage && <div
          className='notification__button --secFont'
          onClick={() => {
            push('/chat')
            dispatch(removeNotification({ notificationId: id }))
          }}>
          {t('see')}
        </div>}
        <div
          className='notification__button--close'
          onClick={() => {
            dispatch(removeNotification({ notificationId: id }))
          }}>
          <i className='icon icon--close' />
        </div>
      </div>
    </div>
  )
}

export default Notification